import { widgetDataSymbol } from '../WidgetData.js'

export function widgetMagic(node: Node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return null

  const el = node as HTMLElement
  let targetEl = el.parentElement
  let result = null
  while (targetEl) {
    const closestStack: (object & { [widgetDataSymbol]?: any })[] = Alpine.closestDataStack(targetEl)
    result = closestStack.find((obj) => obj[widgetDataSymbol])
    if (result) {
      break
    }
    targetEl = targetEl.parentElement
  }

  return result
}
